// extracted by mini-css-extract-plugin
module.exports = {"root":"SummaryCard_root__qRi6K","rows":"SummaryCard_rows__dJ_Ou","row":"SummaryCard_row__eEkcs","value":"SummaryCard_value__c75hz"};